export default __webpack_public_path__ + "static/media/a2-3-0.fdbf8598.jpg";